/**
 * Fields shared by every provider type: name, display name, enabled, type.
 */

import type { ReactElement } from 'react';
import type { ProviderFormData, SetProviderField } from './providerFormTypes';

interface CommonProviderFieldsProps {
  form: ProviderFormData;
  setField: SetProviderField;
  isEdit: boolean;
}

export function CommonProviderFields({
  form,
  setField,
  isEdit,
}: CommonProviderFieldsProps): ReactElement {
  return (
    <>
      <label className="dialog__field">
        Name
        <input
          value={form.name}
          onChange={(e) => { setField('name', e.target.value); }}
          required
          {...(isEdit ? { disabled: true } : {})}
        />
      </label>
      <label className="dialog__field">
        Display Name
        <input
          value={form.display_name}
          onChange={(e) => { setField('display_name', e.target.value); }}
          required
        />
      </label>
      <label className="dialog__field dialog__field--checkbox">
        <input
          type="checkbox"
          checked={form.enabled}
          onChange={(e) => { setField('enabled', e.target.checked); }}
        />
        Enabled
      </label>
      <label className="dialog__field">
        Type
        <select
          value={form.type}
          onChange={(e) => { setField('type', e.target.value as 'oidc' | 'static'); }}
        >
          <option value="oidc">OIDC</option>
          <option value="static">Static Secret</option>
        </select>
      </label>
    </>
  );
}
